import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslyCheckbox } from '@app/components';
import moment from 'moment';
import { Calendar } from '@itglue/kaseya-ui';

interface IProps {
    checkValidation: Function;
    patchData: IData;
}

interface IData {
    days: string[];
    time: string;
}

export const TimeSelector = (props: IProps) => {
    const { checkValidation, patchData } = props;

    const { translation } = useTypedTranslation();

    const [timezone] = useState<string>(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [selectedWeekdays, setSelectedWeekdays] = useState<string[]>(patchData?.days ?? []);
    const initialTime = new Date();
    const hoursAndMinutes = patchData?.time?.split(':');
    hoursAndMinutes && initialTime.setUTCHours(Number(hoursAndMinutes[0]));
    hoursAndMinutes && initialTime.setMinutes(Number(hoursAndMinutes[1]));
    const [time, setTime] = useState<Date | string>(patchData?.time ? initialTime : '');

    const weekdays = moment.weekdays();

    const selectWeekday = (selected: string) => () => {
        const temp: string[] = selectedWeekdays;

        if (temp.some((weekday: string) => weekday === selected)) {
            setSelectedWeekdays([...temp.filter((weekday: string) => weekday !== selected)]);
        } else {
            setSelectedWeekdays([...temp, selected]);
        }
    };

    const handleSelectTime = (event: any) => {
        if (moment(event.value).isValid()) {
            const dateObj = new Date(event.value);
            const result = new Date();

            result.setHours(dateObj.getHours());
            result.setMinutes(dateObj.getMinutes());

            setTime(result);
        }
    };

    useEffect(() => {
        if (selectedWeekdays.length && time !== '') {
            const dateObj = new Date(time);
            const data: IData = {
                days: selectedWeekdays,
                time: `${dateObj.getUTCHours()}:${dateObj.getMinutes()}`
            };
            checkValidation(true, data);
        } else {
            checkValidation(false, null);
        }
    }, [selectedWeekdays, time]);

    return (
        <div className='timeSelector'>
            <div className='timeSelector__block'>
                <Calendar
                    name='expirationDate'
                    label={translation('SELECT_TIME')}
                    value={time}
                    onChange={handleSelectTime}
                    timeOnly={true}
                    hourFormat='12'
                    placeholder='--:-- --'
                />
                <span className='timeSelector__timezone'>{timezone}</span>
            </div>
            <div className='timeSelector__days'>
                {weekdays.map((weekday: string, i: number) => (
                    <PasslyCheckbox
                        key={i}
                        className='timeSelector__day'
                        name='active'
                        checked={selectedWeekdays.some((day: string) => day === weekday)}
                        onChange={selectWeekday(weekday)}
                        label={weekday}
                    />
                ))}
            </div>
        </div>
    );
};
